//Animation reveal titres
const ratio = .1
const options = {
    root: null,
    rootMargin: '0px',
    threshold: ratio
}
const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.intersectionRatio > ratio) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
        }
    })
}
window.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver(handleIntersect, options)
    const targets = document.querySelectorAll('.reveal');
    targets.forEach(function (target) {
        observer.observe(target);
    })
})


document.addEventListener("DOMContentLoaded", function () {


// Appel de la gestion de cookies RGPD
    var cookies = document.querySelector(".cookies");
    cookies.addEventListener("click", function (e) {
        e.preventDefault();
        if (tarteaucitron) {
            tarteaucitron.userInterface.openPanel();
        }
    });

    /*=============================================>>>>>
  = Topbut =
  ===============================================>>>>>*/
    var btn = document.querySelector("#topbut");
    window.addEventListener("scroll", function () {
        if (window.scrollY > 300) {
            btn.classList.add("visible");
        } else {
            btn.classList.remove("visible");
        }
    });
    btn.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector("html").scrollTop = 0;
        document.querySelector("body").scrollTop = 0;
    });





    /*=============================================>>>>>
    = Filtres actualités =
    ===============================================>>>>>*/
    let actualites = document.getElementById('actualites');
    if (actualites) {
        ajaxActus();
    }

    let items = document.querySelectorAll('.cat-list_item');

    for (let i = 0; i < items.length; i++) {
        items[i].addEventListener('click', function() {
            let categoriesList = document.querySelector("#categories-list");
            categoriesList.style.display = categoriesList.style.display === "block" ? "none" : "block";

            document.querySelector("#clickToggle").textContent = this.textContent;
            let activeItems = document.querySelectorAll('.cat-list_item.active');
            for (let j = 0; j < activeItems.length; j++) {
                activeItems[j].classList.remove('active');
            }
            this.classList.add('active');
            ajaxActus(this.dataset.slug, this.dataset.type);
        });
    }
    if (document.querySelector("#clickToggle")) {
        document.querySelector("#clickToggle").addEventListener("click", function () {
            document.querySelector("#categories-list").style.display =
                document.querySelector("#categories-list").style.display === "none" ? "block" : "none";
        });
    }

});

function ajaxActus(slug = "", type="post", page = '1') {
    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_actualites',
            category: slug,
            type: type,
            page: page,
        },
        success: function (res) {
            if (res) {
                document.querySelector('#actualites').innerHTML = res;
                let catActive = document.querySelector('.cat-list_item.active');
                let page = document.querySelectorAll(".page-numbers");
                page.forEach(function(element) {
                    element.addEventListener("click", function (e) {
                        e.preventDefault();
                        ajaxActus(catActive.dataset.slug, 'post', this.dataset.page);
                        // document.body.scrollTop = 0;
                        // document.documentElement.scrollTop = 0;
                        document.querySelector('#main').scrollIntoView({
                            behavior: 'smooth'
                        });
                    });
                });
            }
        }
    })
};

